// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Wpfuv","title":"FrontImage_title__wTHC5"};